import { AdminSearchTruckDetailsTable } from '../views/index';
import { AdminTruckSearchList } from '../dtos/index';
import { ENUMERATE_DAYS_BETWEEN_DATES } from '../../utils/date/date-parser';

export const ADMIN_TRUCK_SEARCHES_LIST_TABLE = (
	truckSearchesList: Array<AdminTruckSearchList> = []
): Array<AdminSearchTruckDetailsTable> => {
	let results: Array<AdminSearchTruckDetailsTable> = [];
	if (truckSearchesList.length > 0) {
		truckSearchesList.map((search, index) => {
			let row = {} as AdminSearchTruckDetailsTable;
			row.businessName = search.businessName;
			row.destination = search.destCity + ' ' + search.destState;
			row.email = search.user != null ? search.user.email : '';
			row.matchCount = search.truckSearchResults.length;
			row.origin = search.originCity + ' ' + search.originState;
			row.searchDate = search.createdAt;
			row.id = search.id;
			results.push(row);
			if (
				search.pickupDateStart != undefined &&
				search.pickupDateStart != null &&
				search.pickupDateEnd != undefined &&
				search.pickupDateEnd != null
			) {
				row.availableDates = ENUMERATE_DAYS_BETWEEN_DATES(
					search.pickupDateStart,
					search.pickupDateEnd
				);
			} else {
				row.availableDates = '';
			}
			if (search.trailerTypes != undefined && search.trailerTypes != null) {
				row.trailerType = search.trailerTypes.join(', ');
			} else {
				row.trailerType = '';
			}
		});
	}
	return results;
};
